
$(document).ready(() => {
  new CustomCheckbox();
  const addressList = new AddressList();
  addressList.showErrorMessage();
  // addressList.subscribe((changedInfo) => {
  // })
  ClearShipping();
  ContinueToCheckout();
  AddShippingLine();
  AddressBook(addressList);
  GiftMessage();
  DatePicker(addressList);
  DisplayShippingMessage();
  
});
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0, event);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);
 
class CartAddButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0, event);
    });
  }
}

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        return this.onCartUpdate();
      },
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute("value");
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = "";

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace(
        "[min]",
        event.target.dataset.min,
      );
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace(
        "[max]",
        event.target.max,
      );
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace(
        "[step]",
        event.target.step,
      );
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity("");
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement.getAttribute("name"),
        event.target.dataset.quantityVariantId,
      );
    }
  }

  onChange(event) {
    if (event.target.type == "number") {
      this.validateQuantity(event);
    }
  }

  onCartUpdate() {
    if (this.tagName === "CART-DRAWER-ITEMS") {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html",
          );
          const selectors = ["cart-drawer-items", ".cart-drawer__footer"];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      return fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html",
          );
          const sourceQty = html.querySelector("cart-items");
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  async updateQuantity(line, quantity, event, name, variantId) {
     
    this.enableLoading(line);
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    const eventTarget =
      event.currentTarget instanceof CartRemoveButton ? "clear" : "change";

     if (this.matches('cart-items')) {
        await this.persistCart();
    }
    
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        CartPerformance.measure(
          `${eventTarget}:paint-updated-sections"`,
          () => {
            const quantityElement =
              document.getElementById(`Quantity-${line}`) ||
              document.getElementById(`Drawer-quantity-${line}`);
            const items = document.querySelectorAll(".cart-item");

            if (parsedState.errors) {
              quantityElement.value = quantityElement.getAttribute("value");
              this.updateLiveRegions(line, parsedState.errors);
              return;
            }

            this.classList.toggle("is-empty", parsedState.item_count === 0);
            const cartDrawerWrapper = document.querySelector("cart-drawer");
            const cartFooter = document.getElementById("main-cart-footer");

            if (cartFooter)
              cartFooter.classList.toggle(
                "is-empty",
                parsedState.item_count === 0,
              );
            if (cartDrawerWrapper)
              cartDrawerWrapper.classList.toggle(
                "is-empty",
                parsedState.item_count === 0,
              );

            this.getSectionsToRender().forEach((section) => {
              const elementToReplace =
                document
                  .getElementById(section.id)
                  .querySelector(section.selector) ||
                document.getElementById(section.id);
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector,
              );
            });
            const updatedValue = parsedState.items[line - 1]
              ? parsedState.items[line - 1].quantity
              : undefined;
            let message = "";
            if (
              items.length === parsedState.items.length &&
              updatedValue !== parseInt(quantityElement.value)
            ) {
              if (typeof updatedValue === "undefined") {
                message = window.cartStrings.error;
              } else {
                message = window.cartStrings.quantityError.replace(
                  "[quantity]",
                  updatedValue,
                );
              }
            }
            this.updateLiveRegions(line, message);

            const lineItem =
              document.getElementById(`CartItem-${line}`) ||
              document.getElementById(`CartDrawer-Item-${line}`);
            if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
              cartDrawerWrapper
                ? trapFocus(
                    cartDrawerWrapper,
                    lineItem.querySelector(`[name="${name}"]`),
                  )
                : lineItem.querySelector(`[name="${name}"]`).focus();
            } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
              trapFocus(
                cartDrawerWrapper.querySelector(".drawer__inner-empty"),
                cartDrawerWrapper.querySelector("a"),
              );
            } else if (
              document.querySelector(".cart-item") &&
              cartDrawerWrapper
            ) {
              trapFocus(
                cartDrawerWrapper,
                document.querySelector(".cart-item__name"),
              );
            }
          },
        );

        CartPerformance.measureFromEvent(`${eventTarget}:user-action`, event);

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items",
          cartData: parsedState,
          variantId: variantId,
        });
      })
      .catch(() => {
        this.querySelectorAll(".loading__spinner").forEach((overlay) =>
          overlay.classList.add("hidden"),
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        
        this.disableLoading(line);
        DisplayShippingMessage();    
        location.reload();
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError)
      lineItemError.querySelector(".cart-item__error-text").textContent =
        message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
      mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`,
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`,
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden"),
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`,
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`,
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden"),
    );
  }

  async persistCart() {
    await $.ajax({
        type: "POST",
        url: "/cart/clear.js",
        dataType: "json",
        success: function (response) {
        },
        error: function (response) {
          alert(response.responseJSON.description); // Show error in dialog
        },
    })

      const payload_array = [];
      $(".jq-address-dropdown").each(function (index, element) {

        let firstName = "";
        let lastName = "";
        let email = "";
        let contactNumber = "";
        let postcode = ""
        let companyName = "";
        let address = "";
        let addressDetail = ""
        let city = "";
        let country = "";

        const itemIndex = index + 1;
        let itemAddress = $(".jq-address-" + itemIndex + " option:selected").val()

        if(itemAddress) {
          itemAddress = itemAddress.split(",");

          firstName = itemAddress[0]?.trim();
          lastName = itemAddress[1]?.trim();
          email = itemAddress[2]?.trim();
          contactNumber = itemAddress[3]?.trim();
          postcode = itemAddress[4].trim();
          companyName = itemAddress[5]?.trim();
          address = itemAddress[6]?.trim();
          addressDetail = itemAddress[7]?.trim();
          city = itemAddress[8]?.trim();
          country = "GB";
        }
          
        let dueDate = "";
        const dueDateField = $(".jq-due-date-" + itemIndex).val();
        const quantity = $("#Quantity-" + itemIndex).val();
        
        if(dueDateField !== "Delivery Date") {
          dueDate = dueDateField;
        }
              
        const giftMessage = extractGiftMessage(itemIndex);
        const hasAddress = firstName.trim() !== "";

        const item = {
          id: $(".jq-address-" + itemIndex).data("variant-id"),
          quantity: quantity,
          properties: {
            "first name": hasAddress ? firstName : "",
            "last name": hasAddress ? lastName : "",
            "email": hasAddress? email: "",
            "phone": hasAddress ? contactNumber : "",
            "zip": hasAddress ? postcode : "",
            "company": hasAddress ? companyName : "",
            "address1": hasAddress ? address : "",
            "address2": hasAddress ? addressDetail : "",
            "city": hasAddress ? city : "",
            "country": hasAddress ? country : "",
            "due date": dueDate,
            "gift message": giftMessage,
            _rand: uuid(),
          },
        };

        payload_array.push(item);

      });
        const reversed_array = payload_array.reverse();
        const payload = {
          items: reversed_array,
          attributes: {
            address_checked: true,
            site_id: "spicers",
          },
        };
        await $.ajax({
          type: "POST",
          url: "/cart/add.js",
          dataType: "json",
          data: payload,
          success: function (response) {
            // location.reload();
          },
          error: function (response) {
            alert(response.responseJSON.description); // Show error in dialog
          },
        });
 }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "input",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            }).then(() =>
              CartPerformance.measureFromEvent(
                "note-update:user-action",
                event,
              ),
            );
          }, ON_CHANGE_DEBOUNCE_TIMER),
        );
      }
    },
  );
}
class CustomCheckbox {
  constructor() {
    this.initializeCheckboxes();
    this.loadSavedStates();
  }

  initializeCheckboxes() {
    // Find all checkbox containers
    const checkboxContainers = document.querySelectorAll(".checkbox-container");

    checkboxContainers.forEach((container) => {
      const checkbox = container.querySelector(".custom-checkbox");
      const toggleTarget = container.dataset.toggle;

      // Add click event listener
      container.addEventListener("click", (e) => {
        e.preventDefault();
        this.toggleCheckbox(checkbox, toggleTarget);
      });
    });
  }

  toggleCheckbox(checkboxElement, toggleTarget) {
    // Toggle the visual state
    const isChecked = checkboxElement.classList.contains("checked");

    if (isChecked) {
      checkboxElement.classList.remove("checked");
    } else {
      checkboxElement.classList.add("checked");
    }

    // Handle the toggle functionality
    this.handleToggle(toggleTarget, !isChecked);

    // Save state to localStorage
    this.saveState(toggleTarget, !isChecked);
  }

  handleToggle(toggleTarget, isEnabled) {
    switch (toggleTarget) {
      case "content":
        this.toggleContent(isEnabled);
        break;
      case "darkMode":
        this.toggleDarkMode(isEnabled);
        break;
      case "notifications":
        this.toggleFeature("notifications", isEnabled);
        break;
      case "analytics":
        this.toggleFeature("analytics", isEnabled);
        break;
      case "autoSave":
        this.toggleFeature("autoSave", isEnabled);
        break;
      default:
        console.log(`Toggle ${toggleTarget}:`, isEnabled);
    }
  }

  toggleContent(show) {
    const content = document.getElementById("content");
    if (show) {
      content.classList.add("visible");
    } else {
      content.classList.remove("visible");
    }
  }

  toggleDarkMode(enable) {
    if (enable) {
      document.body.classList.add("dark-mode");
    } else {
      document.body.classList.remove("dark-mode");
    }
  }

  toggleFeature(featureName, enable) {
    const featureElement = document.getElementById(`feature-${featureName}`);
    const featureText =
      featureName.charAt(0).toUpperCase() + featureName.slice(1);

    if (enable) {
      featureElement.textContent = `${featureText}: Enabled`;
      featureElement.classList.add("enabled");
    } else {
      featureElement.textContent = `${featureText}: Disabled`;
      featureElement.classList.remove("enabled");
    }

    // You can add actual functionality here
    console.log(`${featureText} ${enable ? "enabled" : "disabled"}`);
  }

  saveState(key, value) {
    try {
      const states = JSON.parse(localStorage.getItem("checkboxStates") || "{}");
      states[key] = value;
      localStorage.setItem("checkboxStates", JSON.stringify(states));
    } catch (error) {
      console.warn("Could not save checkbox state:", error);
    }
  }

  loadSavedStates() {
    try {
      const states = JSON.parse(localStorage.getItem("checkboxStates") || "{}");

      Object.entries(states).forEach(([key, value]) => {
        const container = document.querySelector(`[data-toggle="${key}"]`);
        if (container && value) {
          const checkbox = container.querySelector(".custom-checkbox");
          checkbox.classList.add("checked");
          this.handleToggle(key, value);
        }
      });
    } catch (error) {
      console.warn("Could not load checkbox states:", error);
    }
  }
}
function DisplayShippingMessage() {
    const messageContainer = $("#drawer-shipping-message")[0]
    let totalQuantity = 0;

    $(".quantity__input").each(function(index, element) {
      const value = $(this).val()
          totalQuantity = totalQuantity + parseInt(value);
        })

        if(totalQuantity >= 10) {
          messageContainer.style.display = "block";
        }
        else {
          messageContainer.style.display = "none";
    }
}
class AddressList {
  constructor () {
    this._observers = []
    this.selectedAddreses = []
    this.giftMessages = []
    this.itemCount = 0;
    this.cartContent = null;
    this.addressesIdentical = false;
    this.giftMessagesIdentical = true;

    this.getCart();
    this.extractSelectedAddresses();
    this.extractGiftMessages();
    this.setupListener();
  }

  getSelectedAddreses() {
    return this.selectedAddreses
  }

  addAddress(newAddress, longerDelivery = false) {
    const oldValue = [...this.selectedAddreses]

    this.selectedAddreses.push(newAddress)
    this._notify("addressList", oldValue, newAddress)
  }

  showErrorMessage () {
    const giftMessageDisclaimer = $("#gift-message-disclaimer")[0];
    const paletteDisclaimer = $("#palette-disclaimer")[0];

    if(this.addressesIdentical && this.itemCount > 9) {
      paletteDisclaimer.style.display = "flex";
    }
    else{
      paletteDisclaimer.style.display = "none";
    }

    if(this.addressesIdentical && !this.giftMessagesIdentical) {
      giftMessageDisclaimer.style.display = "flex";
    }
    else {
      giftMessageDisclaimer.style.display = "none";
    }
  }

  extractSelectedAddresses() {
    const addressDropdown = document.querySelectorAll("select.jq-address-dropdown");
    const selectedAddresesT = Array.from(addressDropdown)
      .filter(select => select.value !== "" && select.value !== "add-new-address")
      .map(select => select.value)

    const oldValue = this.selectedAddreses;

    this.selectedAddreses = selectedAddresesT;
    this._notify("addressList", oldValue, this.selectedAddreses)
  }

  extractGiftMessages() {
      const giftMessagesFields = document.querySelectorAll("input.gift-button");

      const extractedGiftMessages = Array.from(giftMessagesFields).map(input => input.value)
      
      const oldValue = this.giftMessages;
      this.giftMessages = extractedGiftMessages;

      this._notify("giftMessages", oldValue, this.giftMessages)
  }

  getCart() {
    $.ajax({
        type: "GET",
        url: "/cart.js",
        dataType: "json",
        success: (response) => {
          this.cartContent = response;
         
        },
        error: function (response) {
          alert(response.responseJSON.description); // Show error in dialog
        },
      }).done(() => {
          if(this.cartContent != null) {

            const oldValue =  this.itemCount;
            this.itemCount = this.cartContent.item_count;
            
            this._notify("item_count", oldValue, this.itemCount);
          }
      })
  }

  setupListener () {
    $("select.jq-address-dropdown").each((index, elem) => {
      const $select = $(elem);
      $select.data({
        'initialValue': $select.val(),
        'selectIndex': index,
        'previousValue': $select.val()
      })

      // Use delegated event handling for dynamic selects
      $(document).on('change', $select, (event) => {
        const changedSelect = $(event.target)
        const currentValue = changedSelect.val()
        
        this.extractSelectedAddresses()
        const oldAddressesIdentical = this.addressesIdentical
        this.addressesIdentical = this.areAllStringsIdentical(this.selectedAddreses)
        this.showErrorMessage();
        this._notify("addressList", "", this.selectedAddreses )
        this._notify("addressesIdentical", oldAddressesIdentical, this.addressesIdentical)
      })
    });
    

    const giftSubmit = $("#submit-new-giftMessage")
    const giftSubmitAll = $("#add-to-all")
    $(giftSubmit).on('click', () => {
      setTimeout(() => {
        this.extractGiftMessages();
        this.giftMessagesIdentical = this.areAllStringsIdentical(this.giftMessages);
        this.showErrorMessage();
      }, 0);
    })
    $(giftSubmitAll).on('click', ()=> {
      setTimeout(() => {
        this.extractGiftMessages();
        this.giftMessagesIdentical = this.areAllStringsIdentical(this.giftMessages);
        this.showErrorMessage();
      }, 0);
    })
  }

  areAllStringsIdentical(arr) {
    const someEmpty = arr.some(str => str === "Add Gift Message");
    const allEmpty = arr.every(str => str === "Add Gift Message");

    if (someEmpty | allEmpty) return true;

    if (arr.length === 0 | arr.length === 1) return true;
    
    const firstString = arr[0];
    return arr.every(str => str === firstString );
  }

  subscribe(callback) {
    this._observers.push(callback)
  }

  _notify(propertyName, oldValue, newValue) {
    const changedInfo = {
      property: propertyName,
      oldValue: oldValue,
      newValue: newValue,
    }
    this._observers.forEach(callback => callback(changedInfo))
  }
}

async function ClearShipping () {

  const shippingItems = {
    id: 39374699167875,
    quantity: 0,
    properties: { "shipping code": "ND" },
  };

  const shippingItemsNI = {
    id: 39374699298947,
    quantity: 0,
    properties: { "shipping code": "ND" },
  };

  await $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: shippingItems,
  })

  await $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: shippingItemsNI,
  })
}
// Main Functions
function AddressBook(addressList) {
  //Modal

  const modal = document.getElementById("myModal");
  const span = document.getElementsByClassName("close")[0];
  let sourceLineNo = "";

  $(document).on("change", ".jq-address-dropdown", function () {
    const selectedValue = $(this).val();
    if (selectedValue === "add-new-address") {
      modal.style.display = "flex";
      sourceLineNo = $(this).find("option:selected").data("line-no");

      $(this).val($(this).find("option:first").val());
    }
  })

  span.onclick = function () {
    modal.style.display = "none";
  };

  window.onclick = function (event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  };

  //submit address
  $(document).on("click", "#submit-new-address", async function (e) {
    e.preventDefault();
    const parsedAddress = await ParseAddress();
    if (typeof parsedAddress === "string") {
      modal.style.display = "none";
      addressList.addAddress(parsedAddress)
      const newAddress = new Option(parsedAddress, parsedAddress);
      $(newAddress).html(parsedAddress);
      $(".jq-address-dropdown").append(newAddress);
      $(".jq-address-" + sourceLineNo).val(parsedAddress);
      $("#address-form").trigger("reset");
    }
  });

  $(document).on("click", "#submit-new-address-all", async function (e) {
    e.preventDefault();
    const parsedAddress = await ParseAddress();
    
    if (typeof parsedAddress === "string") {
      modal.style.display = "none";
      addressList.addAddress(parsedAddress)
      const newAddress = new Option(parsedAddress, parsedAddress);
      $(newAddress).html(parsedAddress);
      $(".jq-address-dropdown").append(newAddress);
      $(".jq-address-dropdown").val(parsedAddress);
      $("#address-form").trigger("reset");
    }
  })

  async function ParseAddress () {
    let error = false;

    const firstName = removeCommas($("#first-name").val());
    const lastName = removeCommas($("#last-name").val());
    const emailAddress = $("#email").val();
    const contactNumber = removeCommas($("#contact-number").val());
    const postcode = removeCommas($("#postcode").val());
    const companyName = removeCommas($("#company-name").val());
    const address = removeCommas($("#address").val());
    const addressDetail = removeCommas($("#address-detail").val());
    const city = removeCommas($("#city").val());
    const country = "GB"

    const firstNameValid = ValidateField(firstName, 1, 30, "First name");
    const lastNameValid = ValidateField(lastName, 1, 30, "Last name");
    const emailAddressValid = ValidateField(emailAddress, 1, 120, "Email address", true);
    const contactNumberValid = ValidateField(
      contactNumber,
      9,
      12,
      "Contact number",
    );
    const addressValid = ValidateField(address, 1, 30, "Address");
    const cityValid = ValidateField(city, 1, 30, "City");

    const errors = [
      firstNameValid,
      lastNameValid,
      emailAddressValid,
      addressValid,
      cityValid,
    ];

    let errorMessages = "";
    errors.forEach((validationReturn) => {
      if (typeof validationReturn === "string") {
        error = true;
        errorMessages += `${validationReturn} \n`;
      }
    });

    if (!valid_postcode($("#postcode").val())) {
      error = true;
      errorMessages += `The post code you entered was invalid. \n`;
    }

    if(isDestinationNI(postcode)) {
      error = true;
      errorMessages += `We are sorry but we are not shipping to Northern Ireland, Jersey, Guernsey, and Isle of Man at the moment. \n`;
    }

    if(longShippingTime(postcode) && !isDestinationNI(postcode)) {
      alert(`We can't offer next day delivery to this address, shipping will take 2-3 days. \n`);
    }

    await $.ajax({
      type: "GET",
      url: `https://api.getAddress.io/validate/${address} ${addressDetail} ${postcode} ${city}?api-key=hjIQCKiq3kaMRcjmNgrSqA26075&strict=false`,
      dataType: "json",
      success: function (addressCheckerResponse) {
        if(addressCheckerResponse.status === 404){
          error = true;
          errorMessages += `Could not find provided address. \n`;
        }
        if(addressCheckerResponse.status === 300) {
          error = true;
          errorMessages += `Multiple addresses found. Please include more details. \n`;
        }
      },
      error: function (response) {
        alert(response.responseJSON.description); // Show error in dialog
      },
    })

    if (error) {
      alert(errorMessages);
      return error
    }

    let stringForm = "";
    const formData = [
        firstName,
        lastName,
        emailAddress,
        contactNumber,
        postcode,
        companyName,
        address,
        addressDetail,
        city,
        country,
    ];

    formData.map((item) => {
        stringForm = stringForm + item + ", ";
    });

    return stringForm
  }

  function ValidateField(value, min, max, fieldName, email = false) {
    if (min > 0 && (!value || value === "")) {
      return `${fieldName} must not be empty.`;
    }
    if (value.length <= min) {
      return `${fieldName} must be at least ${min} characters long.`;
    }
    if (value.length >= max) {
      return `${fieldName} must not be over ${max} characters long.`;
    }
    if(email){
      const re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
      const result = re.test(value)
      if(result) {
        return false;
      }
      return `${fieldName} is invalid.`
    }
    return false;
  }

  function removeCommas(str) {
    return str.replace(/,/g, "");
  }

  function longShippingTime (postcode) {
    const postCodes = "AB31,AB32,AB33,AB34,AB35,AB36,AB37,AB38,AB39,AB40,AB41,AB42,AB43,AB44,AB45,AB46,AB47,AB48,AB49,AB50,AB51,AB52,AB53,AB54,AB55,AB56,FK17,FK18,FK19,FK20,FK21,HS1,HS2,HS3,HS4,HS5,HS6,HS7,HS8,HS9,IV1,IV2,IV3,IV4,IV5,IV6,IV7,IV8,IV9,IV10,IV11,IV12,IV13,IV14,IV15,IV16,IV17,IV18,IV19,IV20,IV21,IV22,IV23,IV24,IV25,IV26,IV27,IV28,IV29,IV30,IV31,IV32,IV33,IV34,IV35,IV36,IV37,IV38,IV39,IV40,IV41,IV42,IV43,IV44,IV45,IV46,IV47,IV48,IV49,IV50,IV51,IV52,IV53,IV54,IV55,IV56,IV57,IV58,IV59,IV60,IV61,IV62,IV63,KA27,KA28,KW0,KW1,KW2,KW3,KW4,KW5,KW6,KW7,KW8,KW9,KW10,KW11,KW12,KW13,KW14,KW15,KW16,KW17,PA20,PA21,PA22,PA23,PA24,PA25,PA26,PA27,PA28,PA29,PA30,PA31,PA32,PA33,PA34,PA35,PA36,PA37,PA38,PA39,PA40,PA41,PA42,PA43,PA44,PA45,PA46,PA47,PA48,PA49,PA50,PA51,PA52,PA53,PA54,PA55,PA56,PA57,PA58,PA59,PA60,PA61,PA62,PA63,PA64,PA65,PA66,PA67,PA68,PA69,PA70,PA71,PA72,PA73,PA74,PA75,PA76,PA77,PA78,PH15,PH16,PH17,PH18,PH19,PH20,PH21,PH22,PH23,PH24,PH25,PH26,PH27,PH28,PH29,PH30,PH31,PH32,PH33,PH34,PH35,PH36,PH37,PH38,PH39,PH40,PH41,PH42,PH43,PH44,PH45,PH46,PH47,PH48,PH49,PH50,ZE1,ZE2,ZE3,PO30,IM1,IM2,IM3,IM4,IM5,IM6,IM7,IM8,IM9,IM86,IM87,IM88,IM89,IM90,IM91,IM92,IM93,IM94,IM95,IM96,IM97,IM98,IM99,GY1,GY2,GY3,GY4,GY5,GY6,GY7,GY8,GY9,GY10,JE1,JE2,JE3,JE4,JE5,BT1,BT2,BT3,BT4,BT5,BT6,BT7,BT8,BT9,BT10,BT11,BT12,BT13,BT14,BT15,BT16,BT17,BT18,BT19,BT20,BT21,BT22,BT23,BT24,BT25,BT26,BT27,BT28,BT29,BT30,BT31,BT32,BT33,BT34,BT35,BT36,BT37,BT38,BT39,BT40,BT41,BT42,BT43,BT44,BT45,BT46,BT47,BT48,BT49,BT50,BT51,BT52,BT53,BT54,BT55,BT56,BT57,BT58,BT59,BT60,BT61,BT62,BT63,BT64,BT65,BT66,BT67,BT68,BT69,BT70,BT71,BT72,BT73,BT74,BT75,BT76,BT77,BT78,BT79,BT80,BT81,BT82,BT83,BT84,BT85,BT86,BT87,BT88,BT89,BT90,BT91,BT92,BT93,BT94";
    const postCodeArray = postCodes.split(",");

    const normalizedPostcode = postcode.trim().toUpperCase();
    const outwardCode = normalizedPostcode.slice(0, 4).trim();
    
    return postCodeArray.includes(outwardCode);
  }
}
function AddShippingLine() {
  $(document).on("click", ".split-lines-btn", async function (e) {
    e.preventDefault();

    $(this).prop("disabled", true).text("Adding...");
    await persistCart();

    const payload = {
      items: [],
      attributes: {
        address_checked: true,
        site_id: "spicers",
      },
    };

    let variantId = $(this).data("variant-id");
    let key = $(this).data("key");
    let quantity = $(this).data("quantity")
    let indexToRemove = $(this).data("line-item-no") - 1;
    let currentCart = [];
    let addToCart = [];

    await $.ajax({
      type: "GET",
      url: "/cart.js",
      dataType: "json",
      success: function (shopifyCart) {
        currentCart = shopifyCart.items
      },
      error: function (response) {
        alert(response.responseJSON.description); // Show error in dialog
      },
    })

    if(quantity > 1) {
      for(let i = 0; i < quantity - 1; i++) {
        let productData = {
          id: variantId.toString(),
          quantity: "1",
          properties: {
                "first name": "",
                "last name": "",
                "consignee email": "",
                "phone": "",
                "zip": "",
                "company": "",
                "address1": "",
                "address2": "",
                "city": "",
                "country": "",
                "due date": "",
                "gift message": "",
                _rand: uuid(),
          },
        };
        addToCart.push(productData);
      }
    }
    let result = []
    currentCart[indexToRemove].quantity = 1;

    if(currentCart.length - 1 === indexToRemove){
      result = [
        ...currentCart.slice(0, indexToRemove),
        currentCart[indexToRemove],
        ...addToCart,
      ];
    }
    else{
        result = [
        ...currentCart.slice(0, indexToRemove),
        currentCart[indexToRemove],
        ...addToCart,
        ...currentCart.slice(indexToRemove + 1),
      ];
    }
  
    payload.items = result.reverse();

    await $.ajax({
      type: "POST",
      url: "/cart/clear.js",
      dataType: "json",
      error: function (response) {
        alert(response.responseJSON.description);
      },
    })

    await $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: payload,
      success: function (shopifyCart) {
        location.reload();
      },
      error: function (response) {
        alert(response.responseJSON.description); // Show error in dialog
      },
    })
  });
}
function ContinueToCheckout() {
  let shippingQuantityNI = 0;
  let shippingQuantityGB = 0;

  const payload = {
    items: [],
    attributes: {
      address_checked: true,
      site_id: "spicers",
    },
  };

  $(document).on("click", ".custom-checkout", async function (e) {
    let error = CheckCart();

    if (error === false) {

      await $.ajax({
        type: "POST",
        url: "/cart/clear.js",
        dataType: "json",
        error: function (response) {
          alert(response.responseJSON.description); // Show error in dialog
        },
      })

      $(".jq-address-dropdown").each(function (index, element) {
          const itemIndex = index + 1;
          const itemAddress = $(".jq-address-" + itemIndex + " option:selected")
            .val()
            .split(",");
          const firstName = itemAddress[0]?.trim();
          const lastName = itemAddress[1]?.trim();
          const email = itemAddress[2]?.trim();
          const contactNumber = itemAddress[3]?.trim();
          const postcode = itemAddress[4].trim();
          const companyName = itemAddress[5]?.trim();
          const address = itemAddress[6]?.trim();
          const addressDetail = itemAddress[7]?.trim();
          const city = itemAddress[8]?.trim();
          const country = "GB";

          const dueDate = $(".jq-due-date-" + itemIndex).val();
          const giftMessage = extractGiftMessage(itemIndex);
          const shippingCode = returnShippingCode(postcode, itemIndex);
          const quantity = $("#Quantity-" + itemIndex).val();
          const item = {
            id: $(".jq-address-" + itemIndex).data("variant-id"),
            quantity: quantity,
            properties: {
                "first name": firstName,
                "last name": lastName,
                "consignee email": email,
                "phone": contactNumber,
                "zip": postcode,
                "company": companyName,
                "address1": address,
                "address2": addressDetail,
                "city": city,
                "country": country,
                "due date": dueDate,
                "gift message": giftMessage,
                "shipping code": shippingCode,
                _rand: uuid(),
              },
          };

          if (shippingCode !== "RM" && isDestinationNI(postcode)) {
            shippingQuantityNI = shippingQuantityNI + parseInt(quantity);
          }
          if (shippingCode !== "RM" && !isDestinationNI(postcode)) {
            shippingQuantityGB = shippingQuantityGB + parseInt(quantity);
          }
          payload.items.push(item);
        });

        const shippingItems = {
          id: 39374699167875,
          quantity: shippingQuantityGB,
          properties: { "shipping code": "ND" },
        };

        const shippingItemsNI = {
          id: 39374699298947,
          quantity: shippingQuantityNI,
          properties: { "shipping code": "ND" },
        };

        payload.items.push(shippingItems, shippingItemsNI);
        payload.items.reverse();

        await $.ajax({
          type: "POST",
          url: "/cart/add.js",
          dataType: "json",
          data: payload,
          success: function () {
            document.location.href = "/checkout";
          },
          error: function (response) {
            alert(response.responseJSON.description); // Show error in dialog
          },
        });
    }
  });
}
function GiftMessage() {
  const messageModal = document.getElementById("giftMessageModal");
  const span = document.getElementsByClassName("close")[1];
  let sourceLineNo = "";

  span.onclick = function () {
    messageModal.style.display = "none";
  };

  window.onclick = function (event) {
    if (event.target == messageModal) {
      messageModal.style.display = "none";
    }
  };

  $(document).on("click", ".gift-button", function () {
    messageModal.style.display = "flex";
    sourceLineNo = $(this).data("line-no");

    const messageInputField = $("#giftMessage");
    const currentInputField = $(`.add-new-giftMessage-${sourceLineNo}`)
    const currentValue = currentInputField.val();

    messageInputField.val("")

    if( currentValue.toLowerCase() !== "add gift message") {
      messageInputField.val(currentInputField.val())  
    }

  });

  $("#submit-new-giftMessage").on("click", function () {
    const giftMessage = $("#giftMessage").val();
    $("#giftMessage").val("");
    messageModal.style.display = "none";

    $(`.add-new-giftMessage-${sourceLineNo}`).val(giftMessage);
    truncateButtonText(`.add-new-giftMessage-${sourceLineNo}`);
  });

  $("#add-to-all").on("click", function () {
    const giftMessage = $("#giftMessage").val();
    $("#giftMessage").val("");
    messageModal.style.display = "none";

    addGiftMessageToAll(giftMessage);
  });
}
function DatePicker(addressList) {
  updateDatePicker(addressList)
  addressList.subscribe((change) => {
    if (change.property === "addressList") {
      updateDatePicker(addressList)
    }
  });
}

function updateDatePicker(addressList) {

    const currentAddreses = addressList.getSelectedAddreses();
    const postCodes = currentAddreses.map((address) => {
      return address.split(",")[4]
    })
    const delayedShipping = postCodes.map((postcode) => {
      return longShippingTime(postcode)
    })

    const isAfter3PM = isAfter3PM_GMT1()
    const shopifyDateSettings = window.themeSettings.blockedDeliveryDates.replace(/"/g, '');
    const mondayShippingEnabled = window.themeSettings.mondayShippingEnabled;
    const blockedDeliveryDates =  shopifyDateSettings.split(",").map((str => str.trim()))

    const blockedDelayedShippingDates = shopifyDateSettings.split(",").map((str => str.trim()))
    $(".flatpickr-calendar").remove();

    if(isAfter3PM) {
      addBlockedDate(blockedDeliveryDates, 0)
    }

    if(delayedShipping.includes(true)) {
     addBlockedDate(blockedDelayedShippingDates, 4)
    }

    const blockedDateObjects = blockedDeliveryDates.map(dateStr => new Date(dateStr));
    const delayedDatesObjects = blockedDelayedShippingDates.map(dateStr => new Date(dateStr));
    $(".fp-multi-due-date").each(function (index) {
      
      if ($(this)[0]._flatpickr) {
        $(this)[0]._flatpickr.destroy();
      }

      const preOrderDate = $(this).data("preorder");
      let minDateConfig = delayedShipping[index]? delayedDatesObjects.slice(-1)[0] : new Date().fp_incr(1);
      if(preOrderDate.length !== 0 && typeof preOrderDate === "string") {
        const convertToDate = new Date(preOrderDate)
        if(convertToDate > minDateConfig) {
          minDateConfig = convertToDate;
        }
      }
      $(this).flatpickr({
        dateFormat: "d/m/y",
        disable: [...blockedDateObjects,  
          function(date) {
              return (date.getDay() === 0 || date.getDay() === 6);
          }],
        minDate: minDateConfig, 
        "locale": {
          "firstDayOfWeek": 1 // start week on Monday
        }
      });
    });
    addDueDateButton();
    function addBlockedDate (dateArray, dayOffset, dateRange) {
      const today = new Date();
      const blockedDate = new Date(today);

      if((today.getDay() === 5 || today.getDay() === 6 || today.getDay() === 7) && !mondayShippingEnabled) {

        const daysUntilNextMonday = (8 - today.getDay()) % 7;
        blockedDate.setDate(today.getDate() + daysUntilNextMonday + dayOffset);
      }
      else{
        blockedDate.setDate(today.getDate() + 1 + dayOffset);
      }

      dateArray.push(blockedDate.toLocaleDateString("en-CA"))
    }
}
function longShippingTime (postcode) {
    const postCodes = "AB31,AB32,AB33,AB34,AB35,AB36,AB37,AB38,AB39,AB40,AB41,AB42,AB43,AB44,AB45,AB46,AB47,AB48,AB49,AB50,AB51,AB52,AB53,AB54,AB55,AB56,FK17,FK18,FK19,FK20,FK21,HS1,HS2,HS3,HS4,HS5,HS6,HS7,HS8,HS9,IV1,IV2,IV3,IV4,IV5,IV6,IV7,IV8,IV9,IV10,IV11,IV12,IV13,IV14,IV15,IV16,IV17,IV18,IV19,IV20,IV21,IV22,IV23,IV24,IV25,IV26,IV27,IV28,IV29,IV30,IV31,IV32,IV33,IV34,IV35,IV36,IV37,IV38,IV39,IV40,IV41,IV42,IV43,IV44,IV45,IV46,IV47,IV48,IV49,IV50,IV51,IV52,IV53,IV54,IV55,IV56,IV57,IV58,IV59,IV60,IV61,IV62,IV63,KA27,KA28,KW0,KW1,KW2,KW3,KW4,KW5,KW6,KW7,KW8,KW9,KW10,KW11,KW12,KW13,KW14,KW15,KW16,KW17,PA20,PA21,PA22,PA23,PA24,PA25,PA26,PA27,PA28,PA29,PA30,PA31,PA32,PA33,PA34,PA35,PA36,PA37,PA38,PA39,PA40,PA41,PA42,PA43,PA44,PA45,PA46,PA47,PA48,PA49,PA50,PA51,PA52,PA53,PA54,PA55,PA56,PA57,PA58,PA59,PA60,PA61,PA62,PA63,PA64,PA65,PA66,PA67,PA68,PA69,PA70,PA71,PA72,PA73,PA74,PA75,PA76,PA77,PA78,PH15,PH16,PH17,PH18,PH19,PH20,PH21,PH22,PH23,PH24,PH25,PH26,PH27,PH28,PH29,PH30,PH31,PH32,PH33,PH34,PH35,PH36,PH37,PH38,PH39,PH40,PH41,PH42,PH43,PH44,PH45,PH46,PH47,PH48,PH49,PH50,ZE1,ZE2,ZE3,PO30,IM1,IM2,IM3,IM4,IM5,IM6,IM7,IM8,IM9,IM86,IM87,IM88,IM89,IM90,IM91,IM92,IM93,IM94,IM95,IM96,IM97,IM98,IM99,GY1,GY2,GY3,GY4,GY5,GY6,GY7,GY8,GY9,GY10,JE1,JE2,JE3,JE4,JE5,BT1,BT2,BT3,BT4,BT5,BT6,BT7,BT8,BT9,BT10,BT11,BT12,BT13,BT14,BT15,BT16,BT17,BT18,BT19,BT20,BT21,BT22,BT23,BT24,BT25,BT26,BT27,BT28,BT29,BT30,BT31,BT32,BT33,BT34,BT35,BT36,BT37,BT38,BT39,BT40,BT41,BT42,BT43,BT44,BT45,BT46,BT47,BT48,BT49,BT50,BT51,BT52,BT53,BT54,BT55,BT56,BT57,BT58,BT59,BT60,BT61,BT62,BT63,BT64,BT65,BT66,BT67,BT68,BT69,BT70,BT71,BT72,BT73,BT74,BT75,BT76,BT77,BT78,BT79,BT80,BT81,BT82,BT83,BT84,BT85,BT86,BT87,BT88,BT89,BT90,BT91,BT92,BT93,BT94";
    const postCodeArray = postCodes.split(",");

    const normalizedPostcode = postcode.trim().toUpperCase();
    const outwardCodeLong = normalizedPostcode.slice(0, 4).trim();
    const outwardCodeShort = normalizedPostcode.slice(0, 3).trim();
    
    return postCodeArray.includes(outwardCodeLong) || postCodeArray.includes(outwardCodeShort);
  }

function CheckCart() {
  let isError = false;

  $(".jq-address-dropdown").each(function (index, element) {
    const itemIndex = index + 1;
    const dueDate = $(".jq-due-date-" + itemIndex).val();
    const itemAddress = $(".jq-address-" + itemIndex + " option:selected")
      .val()
      .split(",");


    if (dueDate === "Delivery Date") {
      alert("Please pick a delivery date for each item.");
      isError = true;
      return false;
    }

    if (itemAddress.length <= 1) {
      alert("Please add an address to every item.");
      isError = true;
      return false;
    }
  });
  return isError;
}
// Utility Functions
function uuid() {
  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) =>
    (
      +c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (+c / 4)))
    ).toString(16),
  );
}
function valid_postcode(postcode) {
  postcode = postcode.replace(/\s/g, "");
  const regex = /[A-Z]{1,2}[A-Z0-9]{1,2} ?[0-9][A-Z]{2}/i;
  return regex.test(postcode);
}
function truncateButtonText(selector, maxLength = 20) {
  const $btn = $(selector);
  const originalText = $btn.text();

  if (originalText.length > maxLength) {
    const truncated = originalText.substring(0, maxLength) + "...";
    $btn.text(truncated);
    $btn.attr("title", originalText); // Show full text on hover
  }
}
function returnShippingCode(postcode, itemIndex) {
  if (postcode.trim().substring(0, 2).toUpperCase() === "BT") {
    return "ND";
  }
  if (
    $(".jq-address-" + itemIndex)
      .data("title")
      .toLowerCase()
      .includes("penny post")
  ) {
    return "RM";
  }
  return "ND";
}
function isDestinationNI(postcode) {
  const prefix = postcode.trim().slice(0, 2).toUpperCase();
  return ["BT", "IM", "GY", "JE"].includes(prefix);
}
function addGiftMessageToAll(giftMessage) {
  $(".gift-button").each(function () {
    $(this).val(giftMessage);
  });
}
function extractGiftMessage(itemIndex) {
  const message = $(".add-new-giftMessage-" + itemIndex).val();
  if (message === "Add Gift Message") {
    return "";
  }
  return message;
}

function isAfter3PM_GMT1() {
  const now = new Date();
  const currentHour = parseInt(now.toLocaleTimeString("en-US", {
    timeZone: "Europe/Berlin",
    hour: 'numeric',
    hour12: false
  }));

  return currentHour > 15;
}

async function persistCart() {
  await $.ajax({
      type: "POST",
      url: "/cart/clear.js",
      dataType: "json",
      error: function (response) {
        alert(response.responseJSON.description); // Show error in dialog
      },
  })

  const payload_array = [];
  $(".jq-address-dropdown").each(function (index, element) {

    let firstName = "";
    let lastName = "";
    let email = "";
    let contactNumber = "";
    let postcode = ""
    let companyName = "";
    let address = "";
    let addressDetail = ""
    let city = "";
    let country = "";

    const itemIndex = index + 1;
    let itemAddress = $(".jq-address-" + itemIndex + " option:selected").val()

    if(itemAddress) {
      itemAddress = itemAddress.split(",");

      firstName = itemAddress[0]?.trim();
      lastName = itemAddress[1]?.trim();
      email = itemAddress[2]?.trim();
      contactNumber = itemAddress[3]?.trim();
      postcode = itemAddress[4].trim();
      companyName = itemAddress[5]?.trim();
      address = itemAddress[6]?.trim();
      addressDetail = itemAddress[7]?.trim();
      city = itemAddress[8]?.trim();
      country = "GB";
    }
      
    let dueDate = "";
    const dueDateField = $(".jq-due-date-" + itemIndex).val();
    const quantity = $("#Quantity-" + itemIndex).val();
    
    if(dueDateField !== "Delivery Date") {
      dueDate = dueDateField;
    }
          
    const giftMessage = extractGiftMessage(itemIndex);
    const hasAddress = firstName.trim() !== "";

    const item = {
      id: $(".jq-address-" + itemIndex).data("variant-id"),
      quantity: quantity,
      properties: {
        "first name": hasAddress ? firstName : "",
        "last name": hasAddress ? lastName : "",
        "email": hasAddress? email: "",
        "phone": hasAddress ? contactNumber : "",
        "zip": hasAddress ? postcode : "",
        "company": hasAddress ? companyName : "",
        "address1": hasAddress ? address : "",
        "address2": hasAddress ? addressDetail : "",
        "city": hasAddress ? city : "",
        "country": hasAddress ? country : "",
        "due date": dueDate,
        "gift message": giftMessage,
        _rand: uuid(),
      },
    };

    payload_array.push(item);

  });

  const reversed_array = payload_array.reverse();
  const payload = {
    items: reversed_array,
    attributes: {
    address_checked: true,
    site_id: "spicers",
    },
  };
  await $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: payload,
    success: function (response) {
        // location.reload();
    },
    error: function (response) {
        alert(response.responseJSON.description); // Show error in dialog
    }
  });
}

function addDueDateButton() {
 const dueDateInputs = $(".fp-multi-due-date");

  $(".flatpickr-calendar").each(function(index) {
    const calendar = $(this);
    const correspondingInput = dueDateInputs.eq(index);
    const addToAllBtn = $('<button></button>')
      .attr('type', 'button') // Prevent form submission
      .addClass('due-button_all')
      .text('Add to All')
      .on('click', function(event) {

      event.preventDefault();
      event.stopPropagation();

      // Get the selected date from the corresponding input
      const sourceValue = correspondingInput.val();

      dueDateInputs.each(function() {
        $(this).val(sourceValue);
      });

      const flatpickrInstance = correspondingInput[0]._flatpickr;
      if (flatpickrInstance) {
        flatpickrInstance.close();
      }
    });

    calendar.append(addToAllBtn);
  });
}

